export const TOKEN = 'auth:token';

export const TOKENLOCAL = {
  tokenlocal: 'auth:tokenlocal'
}

export const MODULOS_STORAGE = {
  modulos: 'permitidos',
};

export const USER_STORAGE = {
  usesenha: 'use-senha',
  localtoken: 'localtoken',
  useidnuvem: 'user:useidnuvem',
  useidusuario: 'user:useidusuario',
  userId: 'id-usuario',
  empidempresa: 'empidempresa',
};

export const COLETA_STORAGE = {
  idcliente: 'coleta:idcliente',
  createFrom: 'coleta:create-from',
  createBefore: 'coleta:create-before',
  page: 'coleta:page',
  sort: 'coleta:sort',
  search: 'coleta:search',
  textofiltro: 'coleta:textofiltro',
  parametro: 'coleta:parametro',
};


export const ROTA_STORAGE = {
  anterior: 'rota:anterior',
  proxima: 'rota:proxima',
  cadastro: 'rota:cadastro',
};

export const PRESTACAO_STORAGE = {
  idcliente: 'coleta:idcliente',
  createFrom: 'coleta:create-from',
  createBefore: 'coleta:create-before',
  page: 'coleta:page',
  sort: 'coleta:sort',
  search: 'coleta:search',
  textofiltro: 'coleta:textofiltro',
  parametro: 'coleta:parametro',
};

export const PESQUISA_CADASTRO_CLIENTE_STORAGE = {
  anterior: 'rota:anterior',
  proxima: 'rota:proxima',
  cadastro: 'rota:cadastro',
};

export const OPLOCAL_STORAGE = {
  qr: 'qr',
  numerobag: 'numerobag',
};